// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/TicketStatusSection.js
//
// Purpose:
// Ticket Status Distribution
//
// Dashboard Row
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

const COLORS = [

  "#dc2626",
  "#ea580c",
  "#2563eb",
  "#059669",
  "#111827",

];

export default function TicketStatusSection({

  data = [],

  onStatusClick,

}) {

  function handleClick(entry) {

    if (
      !entry ||
      !onStatusClick
    ) {
      return;
    }

    onStatusClick(
      entry.status
    );
  }

  return (

    <DashboardCard

      title="Ticket Status Distribution"

      subtitle="Current service request status breakdown"

      height={450}
    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <PieChart>

          <Pie

            data={data}

            dataKey="count"

            nameKey="status"

            innerRadius={70}

            outerRadius={120}

            paddingAngle={3}

            onClick={handleClick}
          >

            {data.map(
              (entry, index) => (

                <Cell
                  key={index}
                  fill={
                    COLORS[
                      index %
                      COLORS.length
                    ]
                  }
                />

              )
            )}

          </Pie>

          <Tooltip />

          <Legend />

        </PieChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}